import L from "leaflet";
import React from "react";
import { Marker } from "react-leaflet";

const useCustomMarker = (
  iconUrl: string,
  iconUrlRetina: string,
  draggable?: boolean
) => {
  const CustomMarker = React.forwardRef((props: any, forwardRef) => {
    const { position, ...rest } = props;

    const icon = L.icon({
      iconUrl: iconUrl,
      iconRetinaUrl: iconUrlRetina,
      iconSize: [45, 61],
      iconAnchor: [12, 41],
      popupAnchor: [1, -34],
      shadowSize: [100, 100],
    });

    return (
      <Marker
        position={position}
        icon={icon}
        draggable={draggable}
        ref={forwardRef}
        {...rest}
      />
    );
  });

  return {
    CustomMarker,
  };
};

export default useCustomMarker;
